var _path, _path2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkplansiqLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 82,
    viewBox: "0 0 220 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logo-title"
  }, "WLA WorkPlansIQ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logo-title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 41 42 8l42 7-3 40-36 19L12 41Z",
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20 40 22-24 30 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 51,
    fill: "currentColor",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: -1
  }, "WLA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 101,
    y: 48,
    fill: "currentColor",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 25,
    fontWeight: 700,
    letterSpacing: -1.2
  }, "WorkPlansIQ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplansiqLogo);
export default __webpack_public_path__ + "static/media/workplansiq-logo.df491962062cb4e531801ee4dc440e25.svg";
export { ForwardRef as ReactComponent };